import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Text,
  VStack,
  Heading,
  Flex,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Divider,
  useBreakpointValue,
  Textarea,
  Input,
  Card,
  FormControl,
  Select,
  FormLabel,
  useToast,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  HStack,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Grid,
  Spinner,
  IconButton,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Tooltip,
  Tag,
  Badge,
} from "@chakra-ui/react";
import { useSSLErrorHandler } from "../hooks/useSSLErrorHandler";
import SSLCertificateHelper from "../components/SSLCertificateHelper";
import EnderecoPorCoordenadas from "../components/EnderecoPorCoordenadas";
import { formatDate } from "../helpers/Functions";
import {
  MdAccessTime,
  MdOutlineSecurityUpdateWarning,
  MdOutlineWarningAmber,
  MdSecurityUpdateWarning,
  MdWarning,
  MdHistory,
} from "react-icons/md";
import { FiCalendar, FiTrash2 } from "react-icons/fi";
import { FiInfo } from "react-icons/fi";

import { format } from "date-fns";
import { postAlteracoesMotorista } from "../apis/post-alteracao-apontamentos";
import { postFolgasObs } from "../apis/post-folgas";
import {
  FaCalendar,
  FaSave,
  FaStickyNote,
  FaWatchmanMonitoring,
  FaEdit,
  FaUser,
  FaCalendarAlt,
  FaPlus,
  FaArrowLeft,
  FaArrowRight,
  FaRoad,
  FaUtensils,
  FaCoffee,
  FaClock,
  FaHourglassHalf,
  FaBed,
} from "react-icons/fa";
import { postGravarEventoMotorista } from "../apis/post-novos-apontamentos";
import { postExcluirEventoMotorista } from "../apis/excluir-eventos";
import { excluirCPFolga } from "../apis/excluir-cp-folga";
import { useRef } from "react";
import { fetchPapeleta } from "../apis/get-apontamentos-motoristas";
import { MdEvent, MdDelete, MdCheckCircle } from "react-icons/md";
import { useDisclosure as useChakraDisclosure } from "@chakra-ui/react";
import { getAlteracoesPapeleta } from "../apis/get-alteracoes";

function EditarApontamento() {
  const { dataInicial } = useParams();
  const location = useLocation();
  const eventosData = Array.isArray(location.state?.eventos)
    ? location.state.eventos
    : [];

  const navigate = useNavigate();
  const [showContent, setShowContent] = useState(false);
  const { sslError, sslHelperDisclosure, handleError } = useSSLErrorHandler();

  // Centralize o estado dos eventos do dia
  const [eventosDoDia, setEventosDoDia] = useState(eventosData);
  const [isLoadingEventos, setIsLoadingEventos] = useState(false);

  // Estado para navegação de dias
  const [dataAtual, setDataAtual] = useState(dataInicial);
  const [isNavegando, setIsNavegando] = useState(false);

  // Estado para controlar valores temporários dos inputs
  const [horasTemporarias, setHorasTemporarias] = useState({});

  // Estado para logs de alterações
  const [logsAlteracoes, setLogsAlteracoes] = useState([]);

  // Estado para logs do dia (alterações já enviadas)
  const [logsDoDia, setLogsDoDia] = useState(
    Array.isArray(location.state?.logsDoDia) ? location.state.logsDoDia : [],
  );

  // Função central para atualizar eventos após qualquer alteração
  const atualizarEventos = async (dataEspecifica = null) => {
    setIsLoadingEventos(true);
    try {
      const dataParaBuscar = dataEspecifica || dataAtual;

      // Obter o id_motorista de forma robusta
      let idMotorista = eventosDoDia[0]?.id_motorista;

      // Se não temos id_motorista em eventosDoDia, tentar outras fontes
      if (!idMotorista) {
        idMotorista =
          eventosData[0]?.id_motorista ||
          formData.id_motorista ||
          localStorage.getItem("lastMotoristaId");
      }

      if (!idMotorista) {
        throw new Error("Não foi possível determinar o ID do motorista");
      }

      const novosEventos = await fetchPapeleta(
        idMotorista,
        dataParaBuscar,
        dataParaBuscar,
      );
      console.log("📅 Novos eventos carregados:", novosEventos);
      // Garantir que CP/Folga (ex.: feriado) apareça mesmo se a API não devolver linha
      let eventosComCP = Array.isArray(novosEventos) ? [...novosEventos] : [];
      const existeCPNoFetch = eventosComCP.some(
        (ev) =>
          (ev?.obs_compensada && ev.obs_compensada.trim() !== "") ||
          (ev?.data_compensada && ev.data_compensada.trim() !== ""),
      );
      if (!existeCPNoFetch) {
        // Tentar recuperar CP/Folga do payload original da navegação
        const cpOrigemNavegacao = Array.isArray(eventosData)
          ? eventosData.find(
              (ev) =>
                (ev?.obs_compensada && ev.obs_compensada.trim() !== "") ||
                (ev?.data_compensada && ev.data_compensada.trim() !== ""),
            )
          : null;

        if (cpOrigemNavegacao) {
          const descricao = (
            cpOrigemNavegacao.obs_compensada || "CP/Folga"
          ).toUpperCase();
          const cpPlaceholder = {
            id: cpOrigemNavegacao.id || `cp_${dataParaBuscar}`,
            descricao_evento: descricao,
            data_inicial: dataParaBuscar,
            hora_inicial: cpOrigemNavegacao.hora_inicial || ":",
            data_final: dataParaBuscar,
            hora_final: cpOrigemNavegacao.hora_final || ":",
            status: cpOrigemNavegacao.status || "",
            observacao: cpOrigemNavegacao.observacao || "",
            latitude: cpOrigemNavegacao.latitude ?? 0,
            longitude: cpOrigemNavegacao.longitude ?? 0,
            id_motorista: cpOrigemNavegacao.id_motorista || idMotorista,
            id_evento: cpOrigemNavegacao.id_evento || "",
            semana_numero: cpOrigemNavegacao.semana_numero || undefined,
            semana_texto: cpOrigemNavegacao.semana_texto || undefined,
            data_orig_compensacao:
              cpOrigemNavegacao.data_orig_compensacao || "",
            data_compensada: cpOrigemNavegacao.data_compensada || "",
            obs_compensada: cpOrigemNavegacao.obs_compensada || "",
            id_veiculo: cpOrigemNavegacao.id_veiculo || "",
            placa: cpOrigemNavegacao.placa || "",
          };
          eventosComCP.push(cpPlaceholder);
          console.log(
            "➕ Adicionado placeholder de CP/Folga a partir da navegação:",
            cpPlaceholder,
          );
        }
      }
      setEventosDoDia(eventosComCP);

      // Armazenar o id_motorista correto para uso futuro
      if (
        novosEventos &&
        novosEventos.length > 0 &&
        novosEventos[0]?.id_motorista
      ) {
        localStorage.setItem("lastMotoristaId", novosEventos[0].id_motorista);
      }

      // Atualizar também os logs de alterações
      try {
        const novosLogs = await getAlteracoesPapeleta(
          idMotorista,
          dataParaBuscar,
          dataParaBuscar,
        );
        console.log("📋 Novos logs carregados:", novosLogs);
        setLogsDoDia(novosLogs);
      } catch (error) {
        // Tratamento específico para erros SSL
        if (!handleError(error)) {
          console.warn("Erro ao atualizar logs:", error);
        }
      }

      // Limpar valores temporários após atualização
      setHorasTemporarias({});
    } catch (error) {
      // Tratamento específico para erros SSL
      if (!handleError(error)) {
        toast({ title: "Erro ao atualizar eventos", status: "error" });
      }
    } finally {
      setIsLoadingEventos(false);
    }
  };

  // Função para navegar entre dias
  const navegarDia = async (direcao) => {
    // Verificar se temos id_motorista de forma robusta
    const idMotorista =
      eventosDoDia[0]?.id_motorista ||
      eventosData[0]?.id_motorista ||
      formData.id_motorista ||
      localStorage.getItem("lastMotoristaId");

    if (isNavegando || !idMotorista) return;

    setIsNavegando(true);
    try {
      const dataAtualObj = new Date(dataAtual);
      const novaData = new Date(dataAtualObj);

      if (direcao === "anterior") {
        novaData.setDate(novaData.getDate() - 1);
      } else if (direcao === "proximo") {
        novaData.setDate(novaData.getDate() + 1);
      }

      const novaDataFormatada = novaData.toISOString().split("T")[0];
      setDataAtual(novaDataFormatada);

      // Atualizar URL sem recarregar a página
      const novaUrl = `/editar-apontamentos/${novaDataFormatada}`;
      window.history.pushState({}, "", novaUrl);

      // Carregar dados do novo dia
      await atualizarEventos(novaDataFormatada);

      // Limpar logs de alterações ao navegar
      setLogsAlteracoes([]);

      toast({
        title: "Dia alterado",
        description: `Carregando dados de ${formatDate(novaDataFormatada)}`,
        status: "info",
        duration: 2000,
        isClosable: true,
      });
    } catch (error) {
      // Tratamento específico para erros SSL
      if (!handleError(error)) {
        console.error("Erro ao navegar entre dias:", error);
        toast({
          title: "Erro na navegação",
          description: "Não foi possível carregar os dados do dia selecionado.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } finally {
      setIsNavegando(false);
    }
  };

  const toast = useToast(); // Hook do Chakra UI para exibir notificações
  const [loading, setLoading] = useState(false); // Estado para controlar o loading
  const [novoEvento, setNovoEvento] = useState({
    tipo: "",
    hora_inicial: "",
    hora_final: "",
    id_veiculo: "",
    id_motorista: "",
    data_inicial: "",
    data_final: "",
    status: "",
    latitude: 0,
    longitude: 0,
    parte_jornada: "",
    encerramento: "",
    observacao: "",
  });

  console.log("eventosData", eventosData);

  const [loading1, setLoading1] = useState(false);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef();
  const [eventoParaExcluir, setEventoParaExcluir] = useState(null);

  const [formData, setFormData] = useState({
    id_motorista: eventosData[0]?.id_motorista || "", // Esse ID
    data_inicial: dataAtual, // data atual a ser modificada
    data_edicao: new Date().toISOString().split("T")[0], // Data de hoje
    horario_edicao: new Date().toLocaleTimeString("pt-BR", { hour12: false }), // Hora atual
    observacao: "",
    folgas: "",
  });

  // Novos estados para suportar período de férias
  const [isPeriodoFerias, setIsPeriodoFerias] = useState(false);
  const [dataInicialFerias, setDataInicialFerias] = useState("");
  const [dataFinalFerias, setDataFinalFerias] = useState("");
  const [eventosAdicionados, setEventosAdicionados] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isAdicionandoEvento, setIsAdicionandoEvento] = useState(false);
  const [isExcluindoCP, setIsExcluindoCP] = useState(false);
  const [isCardExpanded, setIsCardExpanded] = useState(false);

  // Novo disclosure exclusivo para o modal de novo evento
  const novoEventoDisclosure = useChakraDisclosure();
  // Novo disclosure para o modal de CP/Folga
  const cpFolgaDisclosure = useChakraDisclosure();
  // Disclosure para o modal de confirmação de exclusão de CP
  const excluirCPDisclosure = useChakraDisclosure();

  // Função para limpar campos do modal de CP/Folga
  const limparCamposCPFolga = () => {
    setFormData((prev) => ({
      ...prev,
      folgas: "",
      observacao: "",
    }));
    setIsPeriodoFerias(false);
    setDataInicialFerias("");
    setDataFinalFerias("");
  };

  const OBSERVACOES_COM_PERIODO = ["ferias", "afastamento", "atestado"];
  const permitePeriodoPorObservacao = (observacao) =>
    OBSERVACOES_COM_PERIODO.includes((observacao || "").trim().toLowerCase());
  const obterLabelPeriodo = (observacao) => {
    const obs = (observacao || "").trim().toLowerCase();
    if (obs === "ferias") return "férias";
    if (obs === "afastamento") return "afastamento";
    if (obs === "atestado") return "atestado";
    return "período especial";
  };

  // Função para verificar se o dia tem CP/Folga válida
  const verificarCPFolga = () => {
    // Verifica se há algum evento com obs_compensada válida
    const eventoComCP = eventosDoDia.find((evento) => {
      const temObsCompensada =
        evento.obs_compensada && evento.obs_compensada.trim() !== "";
      const temDataCompensada =
        evento.data_compensada && evento.data_compensada.trim() !== "";

      // Só retorna true se obs_compensada ou data_compensada tiver conteúdo válido
      return temObsCompensada || temDataCompensada;
    });

    return eventoComCP;
  };

  // Função para obter informações da CP/Folga
  const obterInfoCPFolga = () => {
    const eventoCP = verificarCPFolga();
    if (!eventoCP) return null;

    // Verificar se há obs_compensada ou data_compensada
    const obsCompensada = eventoCP.obs_compensada || "";
    const dataCompensada = eventoCP.data_compensada || "";

    // Se não há nenhum dos dois campos preenchidos, retorna null
    if (!obsCompensada.trim() && !dataCompensada.trim()) {
      return null;
    }

    const info = {
      observacao: obsCompensada,
      data: dataCompensada,
      tipo: "",
      campo: "",
    };

    // Determinar o tipo e campo baseado no que está preenchido
    if (obsCompensada.trim()) {
      info.campo = "obs_compensada";
      info.valor = obsCompensada;

      // Determinar o tipo baseado na obs_compensada
      if (obsCompensada.toLowerCase().includes("ferias")) {
        info.tipo = "Férias";
      } else if (obsCompensada.toLowerCase().includes("falta")) {
        info.tipo = "Falta";
      } else if (obsCompensada.toLowerCase().includes("dsr")) {
        info.tipo = "DSR";
      } else if (obsCompensada.toLowerCase().includes("atestado")) {
        info.tipo = "Atestado";
      } else if (obsCompensada.toLowerCase().includes("feriado")) {
        info.tipo = "Feriado";
      } else {
        info.tipo = obsCompensada;
      }
    } else if (dataCompensada.trim()) {
      info.campo = "data_compensada";
      info.valor = dataCompensada;
      info.tipo = "CP/Folga";
    }

    return info;
  };

  // Função para obter informações detalhadas do dia
  const obterInfoDetalhadaDia = () => {
    if (!eventosDoDia || eventosDoDia.length === 0) return null;

    // Coletar todas as observações únicas
    const observacoes = eventosDoDia
      .filter((evento) => evento.observacao && evento.observacao.trim() !== "")
      .map((evento) => evento.observacao.trim())
      .filter((obs, index, arr) => arr.indexOf(obs) === index); // Remove duplicatas

    // Coletar todos os status únicos
    const status = eventosDoDia
      .filter((evento) => evento.status && evento.status.trim() !== "")
      .map((evento) => evento.status.trim())
      .filter((stat, index, arr) => arr.indexOf(stat) === index); // Remove duplicatas

    // Contar tipos de eventos
    const tiposEventos = eventosDoDia.reduce((acc, evento) => {
      const tipo = evento.descricao_evento;
      acc[tipo] = (acc[tipo] || 0) + 1;
      return acc;
    }, {});

    // Calcular duração total
    const duracaoTotal = eventosDoDia.reduce((total, evento) => {
      if (evento.hora_inicial && evento.hora_final) {
        const [horaI, minI] = evento.hora_inicial.split(":").map(Number);
        const [horaF, minF] = evento.hora_final.split(":").map(Number);
        const inicio = horaI * 60 + minI;
        const fim = horaF * 60 + minF;
        return total + (fim - inicio);
      }
      return total;
    }, 0);

    const horas = Math.floor(duracaoTotal / 60);
    const minutos = duracaoTotal % 60;

    return {
      observacoes,
      status,
      tiposEventos,
      duracaoTotal: `${horas}h ${minutos}m`,
      totalEventos: eventosDoDia.length,
      placa: eventosDoDia[0]?.placa || "N/A",
      semana: eventosDoDia[0]?.semana_texto || "N/A",
    };
  };

  // Função para excluir CP/Folga
  const handleExcluirCPFolga = async () => {
    setIsExcluindoCP(true);
    try {
      // Obter informações da CP/Folga para determinar o campo correto
      const infoCP = obterInfoCPFolga();

      if (!infoCP) {
        toast({
          title: "Erro!",
          description:
            "Não foi possível identificar a CP/Folga a ser excluída.",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
        return;
      }

      const dadosExclusao = {
        id_motorista: eventosDoDia[0]?.id_motorista || formData.id_motorista,
        data_inicial: dataAtual,
        campo: infoCP.campo, // Campo específico a ser excluído
        valor: infoCP.valor, // Valor atual para confirmação
      };

      console.log("🗑️ Excluindo CP/Folga:", dadosExclusao);
      const response = await excluirCPFolga(dadosExclusao);
      console.log("✅ Resposta da exclusão:", response);

      toast({
        title: "CP/Folga excluída!",
        description: `A ${infoCP.tipo} foi removida com sucesso.`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      // Atualizar eventos após exclusão
      await atualizarEventos();
      excluirCPDisclosure.onClose();
    } catch (error) {
      console.error("❌ Erro ao excluir CP/Folga:", error);
      toast({
        title: "Erro ao excluir",
        description: error.message || "Não foi possível excluir a CP/Folga.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setIsExcluindoCP(false);
    }
  };

  const generateGoogleMapsUrl = (latitude, longitude) => {
    if (!latitude || !longitude) return "";
    return `https://www.google.com/maps?q=${latitude},${longitude}&hl=es;z=14&output=embed`;
  };

  const handleNavigate = () => {
    navigate(-1);
  };

  console.log("eventosData", eventosData[0].id_motorista);

  const tabSize = useBreakpointValue({ base: "sm", md: "md" });

  const groupByDescricaoEvento = (events) => {
    if (!Array.isArray(events)) return {};
    return events.reduce((acc, event) => {
      const descricao = event.descricao_evento || "Outros";
      if (!acc[descricao]) {
        acc[descricao] = [];
      }
      acc[descricao].push(event);
      return acc;
    }, {});
  };

  const groupedEvents = groupByDescricaoEvento(eventosData);

  const filteredGroupedEvents = {
    "Cálculo Refeição": groupedEvents["REFEICAO"] || [],
    "Cálculo Intervalo": groupedEvents["INTERVALO"] || [],

    "Cálculo Hora Espera": [
      ...(groupedEvents["TEMPO A DISPOSICAO"] || []),
      ...(groupedEvents["TEMPO ESPERA"] || []),
    ],
  };

  console.log("filteredGroupedEvents", filteredGroupedEvents);

  const getColorForGroup = (descricao) => {
    switch (descricao) {
      case "Cálculo Refeição":
        return "yellow.500"; // Cor do grupo 1
      case "Cálculo Intervalo":
        return "blue.500"; // Cor do grupo 2
      default:
        return "red.500"; // Cor padrão
    }
  };

  const [eventos, setEventos] = useState(eventosData); // Estado local para os eventos
  const [eventosState, setEventosState] = useState(eventos);

  const handleHoraTempChange = (id, campo, novoValor) => {
    setHorasTemporarias((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [campo]: novoValor,
      },
    }));
  };

  // Função para limpar valores temporários de um evento específico
  const limparValoresTemporarios = (id) => {
    setHorasTemporarias((prev) => {
      const novo = { ...prev };
      delete novo[id];
      return novo;
    });
  };

  // Função para limpar todos os valores temporários
  const limparTodosValoresTemporarios = () => {
    setHorasTemporarias({});
  };

  const handleHoraChange = (id, campo, novoValor) => {
    console.log("Evento sendo alterado:", id);
    console.log("Campo sendo alterado:", campo);
    console.log("Novo valor:", novoValor);

    // Buscar o evento original para comparar (usar eventosDoDia em vez de eventosData)
    const eventoOriginal = eventosDoDia.find((ev) => ev.id === id);
    console.log("Evento original:", eventoOriginal);

    // Se o novo valor for igual ao original, remover do log
    if (eventoOriginal?.[campo] === novoValor) {
      console.log("Valor voltou ao original. Removendo do log...");
      setLogsAlteracoes((prevLogs) =>
        prevLogs.filter(
          (log) =>
            !(
              log.id === id &&
              log.campo_alterado ===
                (campo === "hora_inicial" ? "horario_inicial" : "horario_final")
            ),
        ),
      );
      return;
    }

    // Criar novo log mantendo apenas a última alteração
    setLogsAlteracoes((prevLogs) => {
      // Remover versões anteriores da mesma alteração antes de adicionar uma nova
      const logsFiltrados = prevLogs.filter(
        (log) =>
          !(
            log.id === id &&
            log.campo_alterado ===
              (campo === "hora_inicial" ? "horario_inicial" : "horario_final")
          ),
      );

      return [
        ...logsFiltrados, // Mantém apenas as alterações mais recentes
        {
          id,
          id_evento: eventoOriginal?.id_evento || "Sem código",
          descricao_evento: eventoOriginal?.descricao_evento || "Desconhecido",
          campo_alterado:
            campo === "hora_inicial"
              ? "horario_inicial"
              : campo === "hora_final"
                ? "horario_final"
                : campo,
          valor_original: eventoOriginal?.[campo] || "--:--",
          novo_valor: novoValor,
          data_alteracao: new Date().toISOString().split("T")[0], // Formato YYYY-MM-DD
          hora_alteracao: new Date().toLocaleTimeString("pt-BR", {
            hour12: false,
          }), // Formato HH:mm:ss
        },
      ];
    });
  };

  const calculateTotalTime = (horaInicial, horaFinal) => {
    const [horaI, minutoI] = horaInicial.split(":").map(Number);
    const [horaF, minutoF] = horaFinal.split(":").map(Number);

    const inicial = new Date(0, 0, 0, horaI, minutoI);
    const final = new Date(0, 0, 0, horaF, minutoF);

    const diff = final - inicial; // diferença em milissegundos
    const horasTotais = Math.floor(diff / (1000 * 60 * 60)); // horas
    const minutosTotais = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)); // minutos

    return `${horasTotais}h ${minutosTotais}m`;
  };

  const handleSubmit = async () => {
    // Verificar se pelo menos um dos campos foi preenchido
    const folgasPreenchido = formData?.folgas && formData.folgas.trim() !== "";
    const observacaoPreenchido =
      formData?.observacao && formData.observacao.trim() !== "";
    const observacaoPermitePeriodo = permitePeriodoPorObservacao(
      formData?.observacao,
    );
    const periodoFeriasPreenchido =
      isPeriodoFerias && dataInicialFerias && dataFinalFerias;

    if (
      !folgasPreenchido &&
      !observacaoPreenchido &&
      !periodoFeriasPreenchido
    ) {
      toast({
        title: "Erro!",
        description:
          "Preencha pelo menos um dos campos: Folgas, Observação ou Período (Férias, Afastamento ou Atestado).",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    // Para período com range, a observação é obrigatória e deve permitir range
    if (isPeriodoFerias && !observacaoPermitePeriodo) {
      toast({
        title: "Erro!",
        description:
          "Para usar período em range, selecione uma observação válida: Férias, Afastamento ou Atestado.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    if (
      isPeriodoFerias &&
      (!formData.observacao || formData.observacao.trim() === "")
    ) {
      toast({
        title: "Erro!",
        description:
          "Para período em range, é obrigatório selecionar uma observação.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    // Validação adicional para período de férias
    if (isPeriodoFerias && dataInicialFerias && dataFinalFerias) {
      if (new Date(dataFinalFerias) < new Date(dataInicialFerias)) {
        toast({
          title: "Erro!",
          description: "A data final deve ser maior ou igual à data inicial.",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
        return;
      }
    }

    setLoading1(true);
    try {
      let requestBody;
      let arrayPeriodo = []; // Declarar fora do if para estar disponível em todo o escopo

      if (isPeriodoFerias && dataInicialFerias && dataFinalFerias) {
        // Gerar array de objetos para período em range
        const dataInicial = new Date(dataInicialFerias);
        const dataFinal = new Date(dataFinalFerias);

        // Gerar um objeto para cada dia do período
        for (
          let data = new Date(dataInicial);
          data <= dataFinal;
          data.setDate(data.getDate() + 1)
        ) {
          const dataFormatada = data.toISOString().split("T")[0];
          arrayPeriodo.push({
            id_motorista: formData.id_motorista,
            data_inicial: dataFormatada,
            data_edicao: formData.data_edicao,
            horario_edicao: formData.horario_edicao,
            observacao: formData.observacao || "ferias",
            folgas: dataFormatada, // Para range, a data da folga é a mesma da data_inicial
          });
        }

        requestBody = arrayPeriodo;
        console.log("📦 Array de período gerado:", arrayPeriodo);
        console.log("📊 Total de dias:", arrayPeriodo.length);
      } else {
        // Formato antigo para compatibilidade
        requestBody = formData;
      }

      const response = await postFolgasObs(requestBody);
      console.log("📥 Resposta da API:", response);

      // Tratar resposta da API
      let successMessage = "Alterações enviadas com sucesso.";
      if (isPeriodoFerias) {
        const diasCount = arrayPeriodo.length || 0;
        const tipoPeriodo = obterLabelPeriodo(formData.observacao);
        successMessage = `Período de ${tipoPeriodo} enviado com sucesso (${diasCount} dias)`;
      }

      // Verificar se a resposta é um array (novo formato) ou objeto (formato antigo)
      if (Array.isArray(response)) {
        // Novo formato - verificar se todos os itens foram processados com sucesso
        const sucessos = response.filter(
          (item) => item.codigo === "201" || item.codigo === "100",
        );
        const erros = response.filter(
          (item) => item.codigo !== "201" && item.codigo !== "100",
        );

        if (erros.length > 0) {
          toast({
            title: "Atenção!",
            description: `${sucessos.length} itens processados com sucesso, ${erros.length} com erro.`,
            status: "warning",
            duration: 4000,
            isClosable: true,
          });
        } else {
          toast({
            title: "Sucesso!",
            description: successMessage,
            status: "success",
            duration: 3000,
            isClosable: true,
          });
        }
      } else {
        // Formato antigo - resposta única
        toast({
          title: "Sucesso!",
          description: successMessage,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      }

      // Limpar campos após sucesso
      if (isPeriodoFerias) {
        setIsPeriodoFerias(false);
        setDataInicialFerias("");
        setDataFinalFerias("");
      }
    } catch (error) {
      toast({
        title: "Erro ao enviar!",
        description: error.message,
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setLoading1(false);
    }
  };

  const formatarBodyRequisicao = () => {
    return logsAlteracoes.map((log) => {
      // Encontra o evento correspondente (se existir)
      const eventoCorrespondente = eventosDoDia.find(
        (ev) => ev.id_evento === log.id_evento,
      );

      return {
        id_motorista: eventosDoDia[0].id_motorista, // ID do motorista (sempre presente)
        id_veiculo: eventosDoDia[0].id_veiculo, // ID do veículo (sempre presente)
        codigo_evento: eventoCorrespondente
          ? eventoCorrespondente.id_evento
          : "000000", // Código do evento ou valor padrão
        data_inicial: dataAtual, // Data inicial do evento (sempre presente)
        hora_inicial: eventoCorrespondente
          ? eventoCorrespondente.hora_inicial
          : eventosDoDia[0].hora_inicial, // Hora inicial do evento ou valor padrão
        campo_alterado:
          log.campo_alterado === "horario_inicial"
            ? "horario_inicial"
            : log.campo_alterado === "horario_final"
              ? "horario_final"
              : log.campo_alterado === "observacao"
                ? "observacao"
                : "folgas", // Campo alterado
        valor_original: log.valor_original, // O valor anterior
        novo_valor: log.novo_valor, // O novo valor digitado
        horario_edicao: log.hora_alteracao, // Horário da edição
        data_edicao: log.data_alteracao, // Data da edição
        observacao: log.campo_alterado === "observacao" ? log.novo_valor : "", // Observação, se aplicável
        folgas: log.campo_alterado === "cp" ? log.novo_valor : "", // Folgas, se aplicável
      };
    });
  };

  const enviarAlteracoes = async () => {
    if (logsAlteracoes.length === 0) {
      toast({
        title: "Nenhuma alteração para enviar",
        status: "info",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);

    // 🔁 Filtrar logs para manter apenas a última alteração de cada campo por ID do evento
    const logsFiltrados = logsAlteracoes.reduce((acc, log) => {
      acc[`${log.id}_${log.campo_alterado}`] = log;
      return acc;
    }, {});

    let logsUnicos = Object.values(logsFiltrados);

    // ❌ Remove alterações onde valor novo é igual ao original
    logsUnicos = logsUnicos.filter(
      (log) => log.novo_valor !== log.valor_original,
    );

    console.log("✅ LOGS PRONTOS PARA REQUISIÇÃO:", logsUnicos);

    if (logsUnicos.length === 0) {
      toast({
        title: "Nenhuma alteração válida para enviar",
        status: "info",
        duration: 3000,
        isClosable: true,
      });
      setLoading(false);
      return;
    }

    // 🕐 Gerar corpo com horário de edição único por item (incluindo segundos)
    const now = new Date();
    const corpoRequisicao = logsUnicos.map((log, index) => {
      const eventoRelacionado =
        eventosDoDia.find((ev) => ev.id === log.id) || eventosDoDia[0];

      // Adicionar segundos incrementais para garantir unicidade
      const dataEditada = new Date(now.getTime() + index * 1000);
      const horario_edicao = dataEditada.toLocaleTimeString("pt-BR", {
        hour12: false,
      }); // HH:mm:ss

      return {
        id: eventoRelacionado.id,
        id_motorista: eventoRelacionado.id_motorista,
        id_veiculo: eventoRelacionado.id_veiculo,
        codigo_evento: log.id_evento,
        data_inicial: dataAtual,
        hora_inicial:
          eventoRelacionado.hora_inicial || eventosDoDia[0].hora_inicial,
        campo_alterado: log.campo_alterado,
        valor_original: log.valor_original,
        novo_valor: log.novo_valor,
        horario_edicao,
        data_edicao: new Date().toISOString().split("T")[0],
      };
    });

    console.log("📦 CORPO FINAL DA REQUISIÇÃO:", corpoRequisicao);

    // Validação adicional antes do envio
    const validacoes = corpoRequisicao.map((item, index) => {
      const eventoOriginal = eventosDoDia.find((ev) => ev.id === item.id);
      const valorTemporario = horasTemporarias[item.id];

      return {
        index,
        id: item.id,
        campo: item.campo_alterado,
        valorOriginal: item.valor_original,
        novoValor: item.novo_valor,
        valorTemporario: valorTemporario
          ? item.campo_alterado === "horario_inicial"
            ? valorTemporario.hora_inicial
            : valorTemporario.hora_final
          : "N/A",
        valorEventoOriginal: eventoOriginal
          ? item.campo_alterado === "horario_inicial"
            ? eventoOriginal.hora_inicial
            : eventoOriginal.hora_final
          : "N/A",
        status:
          item.novo_valor ===
          (valorTemporario
            ? item.campo_alterado === "horario_inicial"
              ? valorTemporario.hora_inicial
              : valorTemporario.hora_final
            : eventoOriginal
              ? item.campo_alterado === "horario_inicial"
                ? eventoOriginal.hora_inicial
                : eventoOriginal.hora_final
              : "N/A")
            ? "✅ OK"
            : "❌ INCONSISTENTE",
      };
    });

    console.log("🔍 VALIDAÇÕES:", validacoes);

    // Verificar se há inconsistências
    const inconsistencias = validacoes.filter(
      (v) => v.status === "❌ INCONSISTENTE",
    );
    if (inconsistencias.length > 0) {
      console.warn("⚠️ INCONSISTÊNCIAS DETECTADAS:", inconsistencias);
      toast({
        title: "Aviso!",
        description: `Detectadas ${inconsistencias.length} inconsistência(s) nos valores. Verifique o console.`,
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
    }

    try {
      const response = await postAlteracoesMotorista(corpoRequisicao);

      if (
        response.codigo === "404" &&
        response.retorno === "registro nao encontrado"
      ) {
        toast({
          title: "Erro!",
          description: "Registro não encontrado. Verifique os dados.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      toast({
        title: "Sucesso!",
        description: "Alterações enviadas com sucesso!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      setLogsAlteracoes([]);
      await atualizarEventos();
    } catch (error) {
      toast({
        title: "Erro!",
        description: "Falha ao enviar alterações. Tente novamente.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSelectChange2 = (e, field) => {
    setFormData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const DebugBody = () => {
    const [debugInfo, setDebugInfo] = useState("");

    useEffect(() => {
      const debugData = {
        eventosDoDia: eventosDoDia,
        horasTemporarias: horasTemporarias,
        logsAlteracoes: logsAlteracoes,
        bodyRequisicao: formatarBodyRequisicao(),
        timestamp: new Date().toISOString(),
      };
      setDebugInfo(JSON.stringify(debugData, null, 2));
    }, [logsAlteracoes, horasTemporarias, eventosDoDia]);

    return (
      <Box p={4} bg="gray.100" borderRadius="md" mt={4}>
        <Text fontSize="md" fontWeight="bold" mb={2}>
          Debug - Estado Atual:
        </Text>
        <Text fontSize="sm" color="gray.600" mb={2}>
          Eventos: {eventosDoDia.length} | Temporários:{" "}
          {Object.keys(horasTemporarias).length} | Logs: {logsAlteracoes.length}
        </Text>
        <Textarea
          value={debugInfo}
          isReadOnly
          size="sm"
          bg="white"
          height="300px"
          fontSize="xs"
        />
      </Box>
    );
  };

  const handleAdicionarEvento = async () => {
    const regrasEvento = {
      "000001": {
        descricao: "DIREÇÃO",
        parte_jornada: "S",
        encerramento: "N",
        status: "",
      },
      "000002": {
        descricao: "REFEIÇÃO",
        parte_jornada: "N",
        encerramento: "N",
        status: "",
      },
      "000003": {
        descricao: "TEMPO ESPERA",
        parte_jornada: "S",
        encerramento: "N",
        status: "CARGA",
      },
      "000004": {
        descricao: "TEMPO A DISPOSICAO",
        parte_jornada: "S",
        encerramento: "N",
        status: "CARGA",
      },
      "000005": {
        descricao: "INTERSTÍCIO",
        parte_jornada: "N",
        encerramento: "S",
        status: "",
      },
      "000006": {
        descricao: "DESCANSO SEMANAL",
        parte_jornada: "N",
        encerramento: "N",
        status: "",
      },
      "000007": {
        descricao: "FÉRIAS",
        parte_jornada: "N",
        encerramento: "N",
        status: "",
      },
      "000008": {
        descricao: "INTERVALO",
        parte_jornada: "N",
        encerramento: "N",
        status: "",
      },
    };

    const regra = regrasEvento[novoEvento.tipo];

    if (!regra) {
      toast({
        title: "Evento inválido",
        description: "Tipo de evento não reconhecido.",
        status: "warning",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    // Obter id_motorista e id_veiculo de forma robusta
    const idMotorista =
      eventosDoDia[0]?.id_motorista ||
      eventosData[0]?.id_motorista ||
      formData.id_motorista ||
      localStorage.getItem("lastMotoristaId");

    const idVeiculo = eventosDoDia[0]?.id_veiculo || eventosData[0]?.id_veiculo;

    if (!idMotorista) {
      toast({
        title: "Erro",
        description: "Não foi possível determinar o ID do motorista.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      setIsAdicionandoEvento(false);
      return;
    }

    if (!idVeiculo) {
      toast({
        title: "Erro",
        description: "Não foi possível determinar o ID do veículo.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      setIsAdicionandoEvento(false);
      return;
    }

    const eventoFormatado = {
      id_veiculo: idVeiculo,
      id_motorista: idMotorista,
      codigo_evento: novoEvento.tipo,
      data_inicial: dataAtual,
      hora_inicial: novoEvento.hora_inicial,
      data_final: dataAtual,
      hora_final: novoEvento.hora_final,
      status: regra.status || novoEvento.status || "",
      latitude: 0,
      longitude: 0,
      parte_jornada: regra.parte_jornada,
      encerramento: regra.encerramento,
      observacao: novoEvento.observacao || "",
    };

    try {
      console.log("📤 Enviando para API:", [eventoFormatado]);
      const response = await postGravarEventoMotorista([eventoFormatado]);

      // Verificar se a resposta indica que o registro já existe
      if (
        response &&
        response.codigo === "100" &&
        response.retorno?.includes("já existe")
      ) {
        toast({
          title: "Evento já existe!",
          description:
            response.retorno ||
            "Este evento já foi registrado para este horário.",
          status: "warning",
          duration: 4000,
          isClosable: true,
        });
        setIsAdicionandoEvento(false);
        return;
      }

      // Verificar se a resposta indica sucesso (código 100 com mensagem de sucesso)
      if (
        response &&
        response.codigo === "100" &&
        response.retorno?.includes("sucesso")
      ) {
        await atualizarEventos(); // Atualize eventos após adicionar
        toast({
          title: "Evento adicionado!",
          description: response.retorno || "O evento foi enviado com sucesso.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else if (
        response &&
        (response.codigo === "201" || response.codigo === 201)
      ) {
        // Código 201 também indica sucesso
        await atualizarEventos(); // Atualize eventos após adicionar
        toast({
          title: "Evento adicionado!",
          description: response.retorno || "O evento foi enviado com sucesso.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        // Outros códigos de resposta
        toast({
          title: "Resposta inesperada",
          description: response?.retorno || "Resposta da API não reconhecida.",
          status: "info",
          duration: 4000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Erro ao adicionar evento",
        description:
          error.message || "Ocorreu um erro ao tentar adicionar o evento.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      console.error("❌ Erro ao gravar evento:", error);
    } finally {
      setIsAdicionandoEvento(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => setShowContent(true), 2000); // 3 segundos
    return () => clearTimeout(timer); // Limpa o timer se o componente desmontar
  }, []);

  // Atualizar formData quando dataAtual mudar
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      data_inicial: dataAtual,
    }));
  }, [dataAtual]);

  // Carregar dados iniciais quando o componente montar
  useEffect(() => {
    // Sempre tentar carregar dados do motorista, mesmo se eventosDoDia estiver vazio
    // ou se não tiver id_motorista correto
    if (eventosDoDia.length > 0 && eventosDoDia[0]?.id_motorista) {
      // Se temos dados válidos, usar o id_motorista existente
      atualizarEventos(dataAtual);
    } else if (eventosData.length > 0 && eventosData[0]?.id_motorista) {
      // Se eventosDoDia não tem dados válidos mas eventosData tem, usar eventosData
      setEventosDoDia(eventosData);
      atualizarEventos(dataAtual);
    } else {
      // Se não temos dados válidos, tentar buscar usando o id_motorista do formData
      // ou do localStorage se disponível
      const idMotoristaFallback =
        formData.id_motorista || localStorage.getItem("lastMotoristaId");
      if (idMotoristaFallback) {
        // Temporariamente definir eventosDoDia com dados mínimos para permitir a busca
        setEventosDoDia([{ id_motorista: idMotoristaFallback }]);
        atualizarEventos(dataAtual);
      }
    }
  }, []);

  if (!showContent || isLoadingEventos) {
    return (
      <Flex
        h="100vh"
        align="center"
        justify="center"
        bg="gray.50"
        direction="column"
      >
        <Spinner size="xl" color="red.500" thickness="4px" speed="0.7s" />
        <Text mt={4} color="gray.600" fontWeight="bold">
          {isNavegando
            ? "Navegando entre dias..."
            : "Carregando apontamentos..."}
        </Text>
      </Flex>
    );
  }

  const handleRemoverEvento = (index) => {
    setEventosAdicionados((prev) => prev.filter((_, i) => i !== index));
  };

  const handleExcluirEvento = async (id) => {
    try {
      await postExcluirEventoMotorista({ id });
      await atualizarEventos(); // Atualize eventos após excluir
      toast({
        title: "Evento excluído",
        description: `O evento foi removido com sucesso.`,
        status: "info",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Erro ao excluir",
        description: "Não foi possível excluir o evento.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  };

  // Cabeçalho melhorado
  const motoristaNome = eventosDoDia[0]?.nome_motorista || "Motorista";
  const dataApontamento =
    dataAtual || eventosDoDia[0]?.data_inicial || dataInicial;

  // Novo getEventoIcon com ícones mais intuitivos
  const getEventoIcon = (descricao) => {
    switch (descricao?.toUpperCase()) {
      case "DIREÇÃO":
      case "DIRECAO":
        return <FaRoad color="#E31E2C" title="Direção" />;
      case "REFEIÇÃO":
        return <FaUtensils color="#F6C000" title="Refeição" />;
      case "INTERVALO":
        return <FaCoffee color="#3182CE" title="Intervalo" />;
      case "TEMPO A DISPOSICAO":
        return <FaClock color="#38A169" title="Tempo à disposição" />;
      case "TEMPO ESPERA":
        return <FaHourglassHalf color="#805AD5" title="Tempo de espera" />;
      case "INTERSTÍCIO":
      case "INTERSTICIO":
        return <FaBed color="#718096" title="Interstício" />;
      default:
        return <MdEvent color="#CBD5E0" title="Outro" />;
    }
  };

  // Lista de últimas CPs/Folgas lançadas (mock ou baseada em eventosData se disponível)
  const ultimasCpFolgas = Array.isArray(eventosData)
    ? eventosData
        .filter((ev) => ev.data_compensada || ev.obs_compensada)
        .map((ev) => ({
          data: ev.data_compensada || ev.data_inicial,
          obs: ev.obs_compensada || "",
        }))
    : [];

  return (
    <Box bg="gray.50" minH="100vh">
      {/* HEADER DISRUPTIVO E INOVADOR */}
      {/* Header harmonioso com navegação de dias */}
      <Box
        bg="white"
        borderRadius="xl"
        p={5}
        mb={5}
        border="1px solid"
        borderColor="gray.100"
        boxShadow="0 2px 8px rgba(0, 0, 0, 0.08)"
        _hover={{ boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)" }}
        transition="all 0.2s ease-in-out"
      >
        <Flex justify="space-between" align="center" gap={4}>
          {/* Left Section - Voltar Button */}
          <Button
            leftIcon={<FaArrowLeft />}
            variant="ghost"
            colorScheme="gray"
            size="md"
            onClick={handleNavigate}
            fontWeight="medium"
            _hover={{ bg: "gray.100" }}
            _active={{ bg: "gray.200" }}
          >
            Voltar
          </Button>

          {/* Center Section - Grouped Driver Info + Date Navigation */}
          <VStack spacing={3} flex={1} justify="center" align="center">
            {/* Driver Name - Primary Element */}
            <HStack
              spacing={3}
              px={4}
              py={2}
              borderRadius="lg"
              bg="gradient-to-r from-blue.50 to-indigo.50"
              border="1px solid"
              borderColor="blue.200"
              boxShadow="0 1px 3px rgba(59, 130, 246, 0.1)"
              _hover={{ boxShadow: "0 2px 6px rgba(59, 130, 246, 0.15)" }}
              transition="all 0.2s ease-in-out"
            >
              <Box as={FaUser} color="blue.600" fontSize="md" />
              <Text
                fontSize="md"
                fontWeight="bold"
                color="blue.800"
                lineHeight="1.2"
              >
                {motoristaNome}
              </Text>
            </HStack>

            {/* Date and Navigation */}
            <HStack spacing={4} align="center">
              <HStack spacing={1}>
                <Button
                  leftIcon={<FaArrowLeft />}
                  variant="ghost"
                  colorScheme="gray"
                  size="sm"
                  onClick={() => navegarDia("anterior")}
                  isDisabled={isNavegando}
                  fontWeight="medium"
                  _hover={{ bg: "gray.100" }}
                  _active={{ bg: "gray.200" }}
                >
                  Anterior
                </Button>
                <HStack
                  spacing={2}
                  px={3}
                  py={1.5}
                  borderRadius="md"
                  bg="gray.50"
                  border="1px solid"
                  borderColor="gray.200"
                  _hover={{ bg: "gray.100" }}
                  transition="background 0.2s ease-in-out"
                >
                  <Box as={FaCalendarAlt} color="gray.600" fontSize="sm" />
                  <Text fontSize="sm" fontWeight="semibold" color="gray.700">
                    {formatDate(dataApontamento)}
                  </Text>
                </HStack>
                <Button
                  rightIcon={<FaArrowRight />}
                  variant="ghost"
                  colorScheme="gray"
                  size="sm"
                  onClick={() => navegarDia("proximo")}
                  isDisabled={isNavegando}
                  fontWeight="medium"
                  _hover={{ bg: "gray.100" }}
                  _active={{ bg: "gray.200" }}
                >
                  Próximo
                </Button>
              </HStack>

              {isNavegando && (
                <HStack spacing={2} color="blue.500">
                  <Spinner size="sm" />
                  <Text fontSize="sm" fontWeight="medium">
                    Carregando...
                  </Text>
                </HStack>
              )}
            </HStack>
          </VStack>

          {/* Right Section - Action Buttons */}
          <HStack spacing={3} flexShrink={0}>
            <Button
              leftIcon={<FaPlus />}
              colorScheme="blue"
              variant="solid"
              size="md"
              onClick={novoEventoDisclosure.onOpen}
              fontWeight="medium"
              _hover={{
                transform: "translateY(-1px)",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
              }}
              transition="all 0.2s ease-in-out"
            >
              Novo Evento
            </Button>

            <Button
              leftIcon={<FaSave />}
              colorScheme="blue"
              variant="outline"
              size="md"
              onClick={cpFolgaDisclosure.onOpen}
              fontWeight="medium"
              _hover={{ bg: "blue.50", borderColor: "blue.300" }}
              transition="all 0.2s ease-in-out"
            >
              CP / Folga
            </Button>

            <Button
              leftIcon={<FaSave />}
              colorScheme="green"
              variant="solid"
              size="md"
              onClick={enviarAlteracoes}
              isLoading={loading}
              loadingText="Salvando..."
              fontWeight="medium"
              _hover={{
                transform: "translateY(-1px)",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
              }}
              transition="all 0.2s ease-in-out"
            >
              Salvar
            </Button>
          </HStack>
        </Flex>
      </Box>

      {/* Card de Informações de Compensação/Folga */}
      {(() => {
        const infoCP = obterInfoCPFolga();
        const infoDia = obterInfoDetalhadaDia();

        // Só mostra o card se há CP/Folga registrada (obs_compensada preenchida)
        if (!infoCP) return null;

        return (
          <Box
            p={4}
            mx={4}
            mt={4}
            bg="orange.50"
            borderRadius="lg"
            border="2px solid"
            borderColor="orange.300"
            boxShadow="md"
            transition="all 0.3s ease"
          >
            <VStack spacing={4} align="stretch">
              {/* Cabeçalho Minimalista */}
              <HStack justify="space-between" align="center">
                <HStack spacing={3} align="center" flex={1}>
                  <Box bg="orange.500" borderRadius="full" p={2}>
                    <FaStickyNote color="white" size={20} />
                  </Box>
                  <VStack align="start" spacing={1} flex={1}>
                    <HStack spacing={2} align="center">
                      <Text fontWeight="bold" color="orange.700" fontSize="lg">
                        Compensações e Folgas
                      </Text>
                      <Badge colorScheme="orange" fontSize="xs">
                        {formatDate(dataAtual)}
                      </Badge>
                    </HStack>
                    <Text fontWeight="bold" fontSize="sm" color="orange.600">
                      {infoCP.tipo}
                    </Text>
                  </VStack>
                </HStack>

                <HStack spacing={2}>
                  {/* Botão de expansão */}

                  {/* Botão de CP/Folga se existir */}
                  {infoCP && (
                    <Button
                      colorScheme="red"
                      variant="outline"
                      size="sm"
                      leftIcon={<MdDelete />}
                      onClick={excluirCPDisclosure.onOpen}
                      _hover={{ bg: "red.50" }}
                    >
                      Excluir CP
                    </Button>
                  )}
                </HStack>
              </HStack>

              {/* Seção expandível com detalhes */}
              {isCardExpanded && (
                <Box
                  pt={4}
                  borderTop="1px solid"
                  borderColor="orange.200"
                  transition="all 0.3s ease"
                >
                  <VStack spacing={4} align="stretch">
                    {/* CP/Folga se existir */}
                    {infoCP && (
                      <Box
                        p={3}
                        bg="orange.100"
                        borderRadius="md"
                        border="1px solid"
                        borderColor="orange.300"
                      >
                        <HStack spacing={2} align="center" mb={2}>
                          <FaStickyNote color="orange.600" size={16} />
                          <Text
                            fontWeight="bold"
                            color="orange.800"
                            fontSize="sm"
                          >
                            CP/Folga Registrada
                          </Text>
                          {infoCP.data && (
                            <Badge colorScheme="orange" fontSize="xs">
                              {formatDate(infoCP.data)}
                            </Badge>
                          )}
                        </HStack>
                        <VStack align="start" spacing={2}>
                          <HStack spacing={2}>
                            <Text
                              fontSize="xs"
                              color="orange.700"
                              fontWeight="medium"
                            >
                              Tipo:
                            </Text>
                            <Badge colorScheme="orange" fontSize="xs">
                              {infoCP.tipo}
                            </Badge>
                          </HStack>
                          <HStack spacing={2}>
                            <Text
                              fontSize="xs"
                              color="orange.700"
                              fontWeight="medium"
                            >
                              Campo:
                            </Text>
                            <Text fontSize="xs" color="gray.700">
                              obs_compensada
                            </Text>
                          </HStack>
                          <HStack spacing={2}>
                            <Text
                              fontSize="xs"
                              color="orange.700"
                              fontWeight="medium"
                            >
                              Valor:
                            </Text>
                            <Text
                              fontSize="xs"
                              color="gray.700"
                              fontWeight="medium"
                            >
                              {infoCP.observacao}
                            </Text>
                          </HStack>
                        </VStack>
                      </Box>
                    )}
                  </VStack>
                </Box>
              )}
            </VStack>
          </Box>
        );
      })()}

      {/* Modal de Novo Evento */}
      <Box>
        <Modal
          isOpen={novoEventoDisclosure.isOpen}
          onClose={novoEventoDisclosure.onClose}
          isCentered
          size="lg"
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader color="red.600">Adicionar Novo Evento</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Grid
                templateColumns={{ base: "1fr", md: "1fr 1fr 1fr" }}
                gap={4}
              >
                {/* Tipo do Evento */}
                <FormControl isRequired>
                  <FormLabel
                    fontSize="sm"
                    color="gray.700"
                    fontWeight="semibold"
                  >
                    Tipo de Evento
                  </FormLabel>
                  <Select
                    placeholder="Selecione"
                    size="sm"
                    bg="white"
                    borderColor="gray.300"
                    value={novoEvento.tipo}
                    onChange={(e) =>
                      setNovoEvento((prev) => ({
                        ...prev,
                        tipo: e.target.value,
                      }))
                    }
                  >
                    <option value="000001">🚗 Direção</option>
                    <option value="000002">🍽️ Refeição</option>
                    <option value="000003">⏱️ Tempo Espera</option>
                    <option value="000004">⏱️ Tempo a Disposição</option>
                    <option value="000005">💤 Interstício</option>
                    <option value="000006">📅 Descanso Semanal</option>
                    <option value="000007">🏖️ Férias</option>
                    <option value="000008">☕ Intervalo</option>
                  </Select>
                </FormControl>
                {/* Hora Inicial */}
                <FormControl isRequired>
                  <FormLabel
                    fontSize="sm"
                    color="gray.700"
                    fontWeight="semibold"
                  >
                    Hora Inicial
                  </FormLabel>
                  <Input
                    type="time"
                    size="sm"
                    bg="white"
                    borderColor="gray.300"
                    value={novoEvento.hora_inicial}
                    onChange={(e) =>
                      setNovoEvento((prev) => ({
                        ...prev,
                        hora_inicial: e.target.value,
                      }))
                    }
                  />
                </FormControl>
                {/* Hora Final */}
                <FormControl isRequired>
                  <FormLabel
                    fontSize="sm"
                    color="gray.700"
                    fontWeight="semibold"
                  >
                    Hora Final
                  </FormLabel>
                  <Input
                    type="time"
                    size="sm"
                    bg="white"
                    borderColor="gray.300"
                    value={novoEvento.hora_final}
                    onChange={(e) =>
                      setNovoEvento((prev) => ({
                        ...prev,
                        hora_final: e.target.value,
                      }))
                    }
                  />
                </FormControl>
              </Grid>
            </ModalBody>
            <ModalFooter>
              <Button
                onClick={novoEventoDisclosure.onClose}
                variant="ghost"
                mr={3}
              >
                Cancelar
              </Button>
              <Button
                colorScheme="red"
                onClick={async () => {
                  setIsAdicionandoEvento(true);
                  await handleAdicionarEvento();
                  setIsAdicionandoEvento(false);
                  novoEventoDisclosure.onClose();
                }}
                isDisabled={
                  isAdicionandoEvento ||
                  !novoEvento?.tipo ||
                  !novoEvento?.hora_inicial ||
                  !novoEvento?.hora_final
                }
                isLoading={isAdicionandoEvento}
                loadingText="Adicionando..."
              >
                Adicionar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>

      {/* Modal de CP/Folga */}
      <Modal
        isOpen={cpFolgaDisclosure.isOpen}
        onClose={() => {
          limparCamposCPFolga();
          cpFolgaDisclosure.onClose();
        }}
        isCentered
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="red.600">
            Enviar Compensação (CP) e Folga
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form
              id="cp-folga-form"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <VStack spacing={6} align="stretch">
                {/* Seção de Período de Férias */}
                <Box
                  p={4}
                  bg="blue.50"
                  borderRadius="lg"
                  border="1px solid"
                  borderColor="blue.200"
                >
                  <HStack mb={3} align="center">
                    <Box bg="blue.500" borderRadius="full" p={2}>
                      <FaCalendar color="white" size={16} />
                    </Box>
                    <Text fontWeight="bold" color="blue.700">
                      Período de Datas
                    </Text>
                  </HStack>
                  <Text fontSize="xs" color="blue.700" mb={3}>
                    Disponível para: Férias, Afastamento e Atestado.
                  </Text>
                  <HStack spacing={4} align="center">
                    <FormControl>
                      <FormLabel
                        fontSize="sm"
                        color="blue.700"
                        fontWeight="semibold"
                      >
                        Data Inicial
                      </FormLabel>
                      <Input
                        type="date"
                        value={dataInicialFerias}
                        onChange={(e) => setDataInicialFerias(e.target.value)}
                        size="sm"
                        bg="white"
                        borderColor="blue.300"
                        isDisabled={!isPeriodoFerias}
                      />
                    </FormControl>
                    <FormControl>
                      <FormLabel
                        fontSize="sm"
                        color="blue.700"
                        fontWeight="semibold"
                      >
                        Data Final
                      </FormLabel>
                      <Input
                        type="date"
                        value={dataFinalFerias}
                        onChange={(e) => setDataFinalFerias(e.target.value)}
                        size="sm"
                        bg="white"
                        borderColor="blue.300"
                        isDisabled={!isPeriodoFerias}
                      />
                    </FormControl>
                    <FormControl>
                      <FormLabel
                        fontSize="sm"
                        color="blue.700"
                        fontWeight="semibold"
                      >
                        Ativar
                      </FormLabel>
                      <Button
                        size="sm"
                        colorScheme={isPeriodoFerias ? "blue" : "gray"}
                        variant={isPeriodoFerias ? "solid" : "outline"}
                        onClick={() => setIsPeriodoFerias(!isPeriodoFerias)}
                        width="100px"
                        isDisabled={
                          !permitePeriodoPorObservacao(formData.observacao) &&
                          !isPeriodoFerias
                        }
                      >
                        {isPeriodoFerias ? "Ativo" : "Inativo"}
                      </Button>
                    </FormControl>
                  </HStack>
                  {!permitePeriodoPorObservacao(formData.observacao) &&
                    !isPeriodoFerias && (
                      <Text mt={2} fontSize="xs" color="orange.700">
                        Selecione a observação Férias, Afastamento ou Atestado
                        para ativar o período de data.
                      </Text>
                    )}
                  {isPeriodoFerias && dataInicialFerias && dataFinalFerias && (
                    <Box
                      mt={3}
                      p={2}
                      bg={
                        new Date(dataFinalFerias) >= new Date(dataInicialFerias)
                          ? "blue.100"
                          : "red.100"
                      }
                      borderRadius="md"
                    >
                      <Text
                        fontSize="sm"
                        color={
                          new Date(dataFinalFerias) >=
                          new Date(dataInicialFerias)
                            ? "blue.800"
                            : "red.800"
                        }
                        fontWeight="medium"
                      >
                        {new Date(dataFinalFerias) >=
                        new Date(dataInicialFerias) ? (
                          <>
                            📅 Período: {dataInicialFerias} até{" "}
                            {dataFinalFerias}(
                            {Math.ceil(
                              (new Date(dataFinalFerias) -
                                new Date(dataInicialFerias)) /
                                (1000 * 60 * 60 * 24),
                            ) + 1}{" "}
                            dias)
                          </>
                        ) : (
                          "⚠️ Data final deve ser maior ou igual à data inicial"
                        )}
                      </Text>
                      {new Date(dataFinalFerias) >=
                        new Date(dataInicialFerias) && (
                        <Text fontSize="xs" color="blue.600" mt={1}>
                          💡 Lembre-se de selecionar uma observação na seção
                          abaixo (Férias, Afastamento ou Atestado).
                        </Text>
                      )}
                    </Box>
                  )}
                </Box>

                {/* Seção de CP/Folga Individual */}
                <Box
                  p={4}
                  bg={isPeriodoFerias ? "red.50" : "green.50"}
                  borderRadius="lg"
                  border="1px solid"
                  borderColor={isPeriodoFerias ? "red.200" : "green.200"}
                  transition="all 0.3s ease"
                >
                  <HStack mb={3} align="center">
                    <Box
                      bg={isPeriodoFerias ? "red.500" : "green.500"}
                      borderRadius="full"
                      p={2}
                    >
                      <FaStickyNote color="white" size={16} />
                    </Box>
                    <Text
                      fontWeight="bold"
                      color={isPeriodoFerias ? "red.700" : "green.700"}
                    >
                      {isPeriodoFerias
                        ? "CP/Folga Individual (OBRIGATÓRIO)"
                        : "CP/Folga Individual"}
                    </Text>
                  </HStack>
                  <Grid
                    templateColumns={{ base: "1fr", md: "1fr 1fr" }}
                    gap={4}
                  >
                    <FormControl>
                      <FormLabel
                        fontSize="sm"
                        color={isPeriodoFerias ? "gray.500" : "green.700"}
                        fontWeight="semibold"
                      >
                        Compensação (CP){" "}
                        {isPeriodoFerias && (
                          <span style={{ color: "gray" }}>(opcional)</span>
                        )}
                      </FormLabel>
                      <Input
                        type="date"
                        value={formData.folgas}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            folgas: e.target.value,
                          }))
                        }
                        size="sm"
                        bg={isPeriodoFerias ? "gray.50" : "white"}
                        borderColor={isPeriodoFerias ? "gray.300" : "green.300"}
                        isDisabled={isPeriodoFerias}
                      />
                    </FormControl>
                    <FormControl isRequired={isPeriodoFerias}>
                      <FormLabel
                        fontSize="sm"
                        color={isPeriodoFerias ? "red.600" : "green.700"}
                        fontWeight="semibold"
                      >
                        Observação{" "}
                        {isPeriodoFerias && (
                          <span style={{ color: "red" }}>*</span>
                        )}
                      </FormLabel>
                      <Select
                        placeholder={
                          isPeriodoFerias
                            ? "OBRIGATÓRIO para range"
                            : "Selecione uma opção"
                        }
                        size="sm"
                        bg="white"
                        borderColor={isPeriodoFerias ? "red.400" : "green.300"}
                        _hover={{
                          borderColor: isPeriodoFerias
                            ? "red.500"
                            : "green.400",
                        }}
                        _focus={{
                          borderColor: isPeriodoFerias ? "red.500" : "blue.500",
                          boxShadow: isPeriodoFerias
                            ? "0 0 0 1px #E53E3E"
                            : "outline",
                        }}
                        rounded="md"
                        value={formData.observacao}
                        onChange={(e) => {
                          const novaObservacao = e.target.value;
                          setFormData((prev) => ({
                            ...prev,
                            observacao: novaObservacao,
                          }));

                          if (
                            isPeriodoFerias &&
                            !permitePeriodoPorObservacao(novaObservacao)
                          ) {
                            setIsPeriodoFerias(false);
                            setDataInicialFerias("");
                            setDataFinalFerias("");
                          }
                        }}
                        isInvalid={isPeriodoFerias && !formData.observacao}
                      >
                        <option value="falta">FALTA</option>
                        <option value="dsr_cg">DSR CG</option>
                        <option value="dsr_noutrocidade">
                          DSR NOUTRA CIDADE
                        </option>
                        <option value="ferias">FÉRIAS</option>
                        <option value="afastamento">AFASTAMENTO</option>
                        <option value="atestado">ATESTADO MÉDICO</option>
                        <option value="feriado">FERIADO</option>
                        <option value="teste">TESTE</option>
                      </Select>
                      {isPeriodoFerias && !formData.observacao && (
                        <Text fontSize="xs" color="red.500" mt={1}>
                          ⚠️ Este campo é obrigatório para envio em range
                        </Text>
                      )}
                    </FormControl>
                  </Grid>
                </Box>

                {/* Lista das últimas CPs/Folgas lançadas */}
                {ultimasCpFolgas.length > 0 && (
                  <Box p={3} bg="gray.50" borderRadius="md" boxShadow="sm">
                    <Text
                      fontWeight="bold"
                      color="gray.700"
                      mb={2}
                      fontSize="sm"
                    >
                      Últimas CPs/Folgas lançadas:
                    </Text>
                    <ul style={{ margin: 0, paddingLeft: 16 }}>
                      {ultimasCpFolgas.map((item, idx) => (
                        <li
                          key={idx}
                          style={{
                            fontSize: 13,
                            color: "#444",
                            marginBottom: 2,
                          }}
                        >
                          <strong>{item.data}</strong>
                          {item.obs ? ` — ${item.obs}` : ""}
                        </li>
                      ))}
                    </ul>
                  </Box>
                )}
              </VStack>
            </form>
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={() => {
                limparCamposCPFolga();
                cpFolgaDisclosure.onClose();
              }}
              variant="ghost"
              mr={3}
            >
              Cancelar
            </Button>
            <Button
              colorScheme="red"
              type="submit"
              form="cp-folga-form"
              isLoading={loading1}
              loadingText="Enviando..."
              leftIcon={<FaSave />}
              px={8}
              borderRadius="full"
              isDisabled={
                (isPeriodoFerias &&
                  (!dataInicialFerias ||
                    !dataFinalFerias ||
                    new Date(dataFinalFerias) < new Date(dataInicialFerias) ||
                    !formData.observacao)) ||
                (!isPeriodoFerias && !formData.folgas && !formData.observacao)
              }
            >
              {isPeriodoFerias
                ? `Enviar ${obterLabelPeriodo(formData.observacao)}`
                : "Enviar CP/Folga"}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal de Confirmação de Exclusão de CP/Folga */}
      <Modal
        isOpen={excluirCPDisclosure.isOpen}
        onClose={excluirCPDisclosure.onClose}
        isCentered
        size="md"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="red.600">
            <HStack spacing={2}>
              <MdWarning color="red.500" size={24} />
              <Text>Confirmar Exclusão</Text>
            </HStack>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody py={6}>
            <VStack spacing={4} align="center">
              <Box bg="red.100" p={4} borderRadius="full">
                <MdDelete color="red.500" size={32} />
              </Box>
              <VStack spacing={2} textAlign="center">
                <Text fontSize="lg" fontWeight="bold" color="gray.700">
                  {(() => {
                    const infoCP = obterInfoCPFolga();
                    return infoCP
                      ? `Excluir ${infoCP.tipo}`
                      : "Excluir CP/Folga";
                  })()}
                </Text>
                <Text fontSize="sm" color="gray.600">
                  Tem certeza que deseja excluir a compensação/folga registrada
                  para o dia{" "}
                  <Text as="span" fontWeight="bold" color="red.600">
                    {formatDate(dataAtual)}
                  </Text>
                  ?
                </Text>

                {/* Detalhes do que será excluído */}
                {(() => {
                  const infoCP = obterInfoCPFolga();
                  if (infoCP) {
                    return (
                      <Box
                        p={3}
                        bg="red.50"
                        borderRadius="md"
                        border="1px solid"
                        borderColor="red.200"
                        w="100%"
                        textAlign="left"
                      >
                        <Text
                          fontSize="sm"
                          fontWeight="bold"
                          color="red.700"
                          mb={2}
                        >
                          📋 Será excluído:
                        </Text>
                        <VStack align="start" spacing={1}>
                          <HStack spacing={2}>
                            <Text
                              fontSize="xs"
                              color="gray.600"
                              fontWeight="medium"
                            >
                              Tipo:
                            </Text>
                            <Badge colorScheme="red" fontSize="xs">
                              {infoCP.tipo}
                            </Badge>
                          </HStack>
                          <HStack spacing={2}>
                            <Text
                              fontSize="xs"
                              color="gray.600"
                              fontWeight="medium"
                            >
                              Campo:
                            </Text>
                            <Badge colorScheme="red" fontSize="xs">
                              {infoCP.campo}
                            </Badge>
                          </HStack>
                          <HStack spacing={2}>
                            <Text
                              fontSize="xs"
                              color="gray.600"
                              fontWeight="medium"
                            >
                              Valor:
                            </Text>
                            <Text
                              fontSize="xs"
                              color="gray.700"
                              fontWeight="medium"
                            >
                              {infoCP.valor}
                            </Text>
                          </HStack>
                          {infoCP.campo === "data_compensada" && (
                            <HStack spacing={2}>
                              <Text
                                fontSize="xs"
                                color="gray.600"
                                fontWeight="medium"
                              >
                                Data Formatada:
                              </Text>
                              <Text fontSize="xs" color="gray.700">
                                {formatDate(infoCP.valor)}
                              </Text>
                            </HStack>
                          )}
                        </VStack>
                      </Box>
                    );
                  }
                  return null;
                })()}

                <Text fontSize="xs" color="red.500" fontWeight="medium">
                  ⚠️ Esta ação não pode ser desfeita.
                </Text>
              </VStack>
            </VStack>
          </ModalBody>
          <ModalFooter gap={3}>
            <Button
              onClick={excluirCPDisclosure.onClose}
              variant="outline"
              colorScheme="gray"
              isDisabled={isExcluindoCP}
            >
              Cancelar
            </Button>
            <Button
              colorScheme="red"
              onClick={handleExcluirCPFolga}
              isLoading={isExcluindoCP}
              loadingText="Excluindo..."
              leftIcon={<MdDelete />}
            >
              {(() => {
                const infoCP = obterInfoCPFolga();
                return infoCP ? `Excluir ${infoCP.tipo}` : "Excluir CP/Folga";
              })()}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Flex direction="column" p={4} mx="auto" gap={8} maxW="1200px" w="100%">
        {/* Tabela de Apontamentos melhorada */}
        <Box
          borderWidth="2px"
          borderRadius="2xl"
          p={6}
          boxShadow="2xl"
          bgGradient="linear(to-br, white, gray.50)"
          w="100%"
          borderColor="#E31E2C"
          mt={6}
        >
          <HStack mb={2} gap={2} align="center">
            <Box
              bg="#E31E2C"
              borderRadius="full"
              p={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <FaEdit color="white" size={28} />
            </Box>
            <Heading as="h2" size="md" color="#E31E2C" fontWeight="bold">
              Editar Apontamentos
            </Heading>
          </HStack>
          <Divider mb={6} />
          <Box
            overflowX="auto"
            borderRadius="lg"
            borderWidth="1px"
            borderColor="gray.200"
            boxShadow="sm"
          >
            <Table
              variant="simple"
              size="sm"
              borderRadius="lg"
              overflow="hidden"
            >
              <Thead bg="red.600">
                <Tr>
                  <Th color="white" fontWeight="bold" fontSize="sm">
                    Evento
                  </Th>
                  <Th color="white" fontWeight="bold" fontSize="sm">
                    Hora Inicial
                  </Th>
                  <Th color="white" fontWeight="bold" fontSize="sm">
                    Hora Final
                  </Th>
                  <Th color="white" fontWeight="bold" fontSize="sm">
                    Duração
                  </Th>
                  <Th color="white" fontWeight="bold" fontSize="sm">
                    Ações
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {eventosDoDia.length === 0 ? (
                  <Tr>
                    <Td colSpan={5} textAlign="center" color="gray.500">
                      Nenhum evento encontrado para este dia.
                    </Td>
                  </Tr>
                ) : (
                  eventosDoDia.map((evento, idx) => {
                    const isAlterado = logsAlteracoes.some(
                      (log) => log.id === evento.id,
                    );
                    // Paleta de cores para pares encaixados (expandida)
                    const encaixeColors = [
                      "#3182ce", // azul
                      "#38a169", // verde
                      "#805ad5", // roxo
                      "#d53f8c", // rosa
                      "#e53e3e", // vermelho
                      "#dd6b20", // laranja
                      "#ecc94b", // amarelo
                      "#00b5d8", // ciano
                      "#5a67d8", // indigo
                      "#319795", // teal
                      "#ed64a6", // pink
                    ];
                    // Verifica se a hora final deste evento é igual à hora inicial do próximo evento
                    const proximoEvento = eventosDoDia[idx + 1];
                    const horaFinalIgualProximaInicial =
                      proximoEvento &&
                      (horasTemporarias[evento.id]?.hora_final ??
                        evento.hora_final) ===
                        (horasTemporarias[proximoEvento.id]?.hora_inicial ??
                          proximoEvento.hora_inicial);
                    // Verifica se a hora inicial deste evento é igual à hora final do evento anterior
                    const eventoAnterior = eventosDoDia[idx - 1];
                    const horaInicialIgualAnteriorFinal =
                      eventoAnterior &&
                      (horasTemporarias[evento.id]?.hora_inicial ??
                        evento.hora_inicial) ===
                        (horasTemporarias[eventoAnterior.id]?.hora_final ??
                          eventoAnterior.hora_final);
                    // Cor do encaixe para este par
                    let encaixeColor = undefined;
                    if (horaFinalIgualProximaInicial) {
                      encaixeColor = encaixeColors[idx % encaixeColors.length];
                    } else if (horaInicialIgualAnteriorFinal) {
                      encaixeColor =
                        encaixeColors[(idx - 1) % encaixeColors.length];
                    }

                    // Calcula a duração do evento
                    const horaInicial =
                      horasTemporarias[evento.id]?.hora_inicial ??
                      evento.hora_inicial;
                    const horaFinal =
                      horasTemporarias[evento.id]?.hora_final ??
                      evento.hora_final;
                    const duracao =
                      horaInicial && horaFinal
                        ? calculateTotalTime(horaInicial, horaFinal)
                        : "--:--";

                    return (
                      <Tr
                        key={evento.id}
                        bg={idx % 2 === 0 ? "gray.50" : "white"}
                        _hover={{ bg: "gray.100" }}
                        transition="background 0.2s"
                      >
                        <Td
                          fontWeight="bold"
                          color="gray.700"
                          display="flex"
                          alignItems="center"
                          gap={2}
                        >
                          {getEventoIcon(evento.descricao_evento)}
                          <span title={evento.descricao_evento}>
                            {evento.descricao_evento}
                          </span>
                          {isAlterado && (
                            <MdCheckCircle
                              color="#38A169"
                              title="Alterado"
                              style={{ marginLeft: 4 }}
                            />
                          )}
                          {logsDoDia.some((log) => {
                            console.log("Comparando:", {
                              logIdMarcacao: log.id_marcacao,
                              eventoId: evento.id,
                              logIdEvento: log.id_evento,
                              eventoIdEvento: evento.id_evento,
                              logNomeEvento: log.nome_evento,
                              eventoDescricaoEvento: evento.descricao_evento,
                              matchIdMarcacao: log.id_marcacao === evento.id,
                              matchIdEvento: log.id_evento === evento.id_evento,
                              matchNomeEvento:
                                log.nome_evento === evento.descricao_evento,
                              resultado: log.id_marcacao === evento.id,
                            });
                            return log.id_marcacao === evento.id;
                          }) && (
                            <Tooltip
                              label={
                                <Box>
                                  <Text fontSize="sm" color="gray.600" mb={1}>
                                    <Text
                                      as="span"
                                      fontWeight="bold"
                                      color="#E31E2C"
                                    >
                                      Campo alterado:
                                    </Text>{" "}
                                    {(() => {
                                      const campo = logsDoDia
                                        .find(
                                          (log) =>
                                            log.id_marcacao === evento.id,
                                        )
                                        ?.campo_alteracao?.toLowerCase();
                                      if (
                                        campo === "horario_inicial" ||
                                        campo === "inserido_inicial"
                                      ) {
                                        return "Horário Inicial";
                                      } else if (
                                        campo === "horario_final" ||
                                        campo === "inserido_final"
                                      ) {
                                        return "Horário Final";
                                      } else if (campo === "inserido") {
                                        return "Inserido";
                                      } else if (campo === "excluido") {
                                        return "Excluído";
                                      } else {
                                        return "Alterado";
                                      }
                                    })()}
                                  </Text>
                                  <Text fontSize="sm" color="gray.600">
                                    <Text
                                      as="span"
                                      fontWeight="bold"
                                      color="#E31E2C"
                                    >
                                      Valor anterior:
                                    </Text>{" "}
                                    {logsDoDia.find(
                                      (log) => log.id_marcacao === evento.id,
                                    )?.hora_original || "--:--"}
                                  </Text>
                                  <Text fontSize="sm" color="gray.600">
                                    <Text
                                      as="span"
                                      fontWeight="bold"
                                      color="#E31E2C"
                                    >
                                      Novo valor:
                                    </Text>{" "}
                                    {logsDoDia.find(
                                      (log) => log.id_marcacao === evento.id,
                                    )?.hora_novo || "--:--"}
                                  </Text>
                                </Box>
                              }
                              fontSize="sm"
                              bg="white"
                              color="gray.700"
                              p={2}
                              borderRadius="md"
                              boxShadow="sm"
                              placement="top"
                              hasArrow
                            >
                              <Box display="flex" alignItems="center">
                                <Badge
                                  colorScheme="purple"
                                  ml={2}
                                  fontSize="xs"
                                  px={2}
                                  py={0.5}
                                  borderRadius="full"
                                >
                                  <HStack spacing={1}>
                                    <MdHistory size={14} />
                                    <Text>
                                      {(() => {
                                        // Buscar todos os logs relacionados ao evento
                                        const logsDoEvento = logsDoDia.filter(
                                          (log) =>
                                            log.id_marcacao === evento.id,
                                        );

                                        // Verificar se algum log contém "inserido"
                                        const temInserido = logsDoEvento.some(
                                          (log) =>
                                            log.campo_alteracao
                                              ?.toLowerCase()
                                              .includes("inserido"),
                                        );

                                        if (temInserido) {
                                          return "Inserido";
                                        } else {
                                          return "Alterado";
                                        }
                                      })()}
                                    </Text>
                                  </HStack>
                                </Badge>
                              </Box>
                            </Tooltip>
                          )}
                        </Td>
                        <Td textAlign="center">
                          <Input
                            type="time"
                            value={
                              horasTemporarias[evento.id]?.hora_inicial ??
                              evento.hora_inicial
                            }
                            size="sm"
                            borderColor={
                              horaInicialIgualAnteriorFinal
                                ? encaixeColors[
                                    (idx - 1) % encaixeColors.length
                                  ]
                                : isAlterado
                                  ? "green.400"
                                  : "gray.300"
                            }
                            focusBorderColor={
                              horaInicialIgualAnteriorFinal
                                ? encaixeColors[
                                    (idx - 1) % encaixeColors.length
                                  ]
                                : "red.500"
                            }
                            onChange={(e) =>
                              handleHoraTempChange(
                                evento.id,
                                "hora_inicial",
                                e.target.value,
                              )
                            }
                            onBlur={(e) =>
                              handleHoraChange(
                                evento.id,
                                "hora_inicial",
                                e.target.value,
                              )
                            }
                            bg={isAlterado ? "green.50" : "white"}
                            borderRadius="md"
                            boxShadow={
                              horaInicialIgualAnteriorFinal
                                ? `0 0 0 0.5px ${
                                    encaixeColors[
                                      (idx - 1) % encaixeColors.length
                                    ]
                                  }`
                                : undefined
                            }
                          />
                        </Td>
                        <Td textAlign="center">
                          <Input
                            type="time"
                            value={
                              horasTemporarias[evento.id]?.hora_final ??
                              evento.hora_final
                            }
                            size="sm"
                            borderColor={
                              horaFinalIgualProximaInicial
                                ? encaixeColors[idx % encaixeColors.length]
                                : isAlterado
                                  ? "green.400"
                                  : "gray.300"
                            }
                            focusBorderColor={
                              horaFinalIgualProximaInicial
                                ? encaixeColors[idx % encaixeColors.length]
                                : "red.500"
                            }
                            onChange={(e) =>
                              handleHoraTempChange(
                                evento.id,
                                "hora_final",
                                e.target.value,
                              )
                            }
                            onBlur={(e) =>
                              handleHoraChange(
                                evento.id,
                                "hora_final",
                                e.target.value,
                              )
                            }
                            bg={isAlterado ? "green.50" : "white"}
                            borderRadius="md"
                            boxShadow={
                              horaFinalIgualProximaInicial
                                ? `0 0 0 0.5px ${
                                    encaixeColors[idx % encaixeColors.length]
                                  }`
                                : undefined
                            }
                          />
                        </Td>
                        <Td textAlign="center">
                          <Badge
                            colorScheme={duracao !== "--:--" ? "blue" : "gray"}
                            fontSize="sm"
                            px={3}
                            py={1}
                            borderRadius="full"
                            fontWeight="semibold"
                          >
                            {duracao}
                          </Badge>
                        </Td>
                        <Td textAlign="center">
                          <Tooltip label="Excluir evento" fontSize="sm">
                            <IconButton
                              icon={<MdDelete />}
                              colorScheme="red"
                              size="sm"
                              aria-label="Excluir evento"
                              onClick={() => {
                                setEventoParaExcluir(evento.id);
                                onOpen();
                              }}
                              variant="ghost"
                              borderRadius="full"
                            />
                          </Tooltip>
                        </Td>
                      </Tr>
                    );
                  })
                )}
              </Tbody>
            </Table>
          </Box>
        </Box>
        <Box
          borderWidth="2px"
          borderRadius="2xl"
          p={6}
          boxShadow="2xl"
          bgGradient="linear(to-br, white, gray.50)"
          w="100%"
          borderColor="#E31E2C"
          mt={6}
        >
          <HStack mb={2} gap={2} align="center">
            <Box
              bg="#E31E2C"
              borderRadius="full"
              p={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <FaCalendarAlt color="white" size={28} />
            </Box>
            <Heading as="h2" size="md" color="#E31E2C" fontWeight="bold">
              Detalhes do Dia - {formatDate(dataAtual) || "Data não disponível"}
            </Heading>
          </HStack>
          <Divider mb={6} />

          <Box
            p={4}
            bg="white"
            borderRadius="lg"
            boxShadow="md"
            borderWidth="1px"
            borderColor="gray.200"
          >
            <Text fontSize="xl" fontWeight="bold" mb={4} color="gray.600">
              Linha do Tempo dos Eventos
            </Text>

            {Array.isArray(eventosDoDia) && eventosDoDia.length > 0 ? (
              <Accordion allowToggle>
                {eventosDoDia.map((ev, idx) => {
                  const eventColors = [
                    "teal.500",
                    "blue.500",
                    "green.500",
                    "orange.500",
                    "red.500",
                    "purple.500",
                  ];
                  const eventColor = eventColors[idx % eventColors.length];
                  return (
                    <AccordionItem key={ev.id || idx} border="none">
                      <h2>
                        <AccordionButton
                          _expanded={{ bg: "gray.100" }}
                          px={2}
                          py={2}
                        >
                          <Box
                            display="flex"
                            alignItems="center"
                            flex="1"
                            textAlign="left"
                            gap={3}
                          >
                            <Box
                              as="span"
                              borderRadius="full"
                              bg={eventColor}
                              w="10px"
                              h="10px"
                            />
                            <Tooltip label={ev.descricao_evento} fontSize="sm">
                              <Box>{getEventoIcon(ev.descricao_evento)}</Box>
                            </Tooltip>
                            <Text
                              fontWeight="bold"
                              color={eventColor}
                              fontSize="md"
                            >
                              {ev.descricao_evento}
                            </Text>
                            <Tag colorScheme="gray" fontSize="sm" ml={2}>
                              {ev.hora_inicial || "--:--"} -{" "}
                              {ev.hora_final || "--:--"}
                            </Tag>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                      </h2>
                      <AccordionPanel
                        pb={4}
                        bg="white"
                        borderRadius="md"
                        boxShadow="sm"
                      >
                        <VStack align="start" spacing={2}>
                          <Text fontSize="sm" color="gray.600">
                            <strong>Horário Inicial:</strong>{" "}
                            {ev.hora_inicial || "Não disponível"}
                          </Text>
                          <Text fontSize="sm" color="gray.600">
                            <strong>Horário Final:</strong>{" "}
                            {ev.hora_final || "Não disponível"}
                          </Text>
                          {ev.observacao && (
                            <Text fontSize="sm" color="gray.500">
                              <strong>Observação:</strong> {ev.observacao} |{" "}
                              <strong>Tipo:</strong> {ev.status}
                            </Text>
                          )}
                          {ev.latitude && ev.longitude && (
                            <>
                              <Text fontSize="sm" color="gray.600">
                                <strong>Latitude:</strong> {ev.latitude} |{" "}
                                <strong>Longitude:</strong> {ev.longitude}
                              </Text>
                              <Text fontSize="sm" color="gray.500">
                                <EnderecoPorCoordenadas
                                  latitude={ev.latitude}
                                  longitude={ev.longitude}
                                />
                              </Text>
                              <Box
                                mt={2}
                                borderRadius="md"
                                overflow="hidden"
                                width="100%"
                                boxShadow="sm"
                                border="1px solid"
                                borderColor="gray.200"
                              >
                                <iframe
                                  title={`Mapa do evento ${
                                    ev.id_evento || idx
                                  }`}
                                  src={generateGoogleMapsUrl(
                                    ev.latitude,
                                    ev.longitude,
                                  )}
                                  width="100%"
                                  height="180"
                                  style={{
                                    border: "none",
                                    borderRadius: "8px",
                                  }}
                                ></iframe>
                              </Box>
                            </>
                          )}
                        </VStack>
                      </AccordionPanel>
                    </AccordionItem>
                  );
                })}
              </Accordion>
            ) : (
              <Text>Nenhum evento encontrado.</Text>
            )}
          </Box>
        </Box>

        {/* Log de Correções - Histórico de Alterações */}
        <Box
          borderWidth="2px"
          borderRadius="2xl"
          p={6}
          boxShadow="2xl"
          bgGradient="linear(to-br, white, gray.50)"
          w="100%"
          borderColor="#E31E2C"
          mt={6}
          mb={4}
        >
          <HStack mb={2} gap={2} align="center">
            <Box
              bg="#E31E2C"
              borderRadius="full"
              p={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <MdHistory color="white" size={28} />
            </Box>
            <Heading as="h2" size="md" color="#E31E2C" fontWeight="bold">
              Log(s) em Correções -{" "}
              {formatDate(dataAtual) || "Data não disponível"}
            </Heading>
          </HStack>
          <Text
            fontSize="lg"
            fontWeight="bold"
            mb={4}
            color="gray.700"
            display="flex"
            alignItems="center"
            gap={2}
          ></Text>
          <Divider mb={4} />
          {isLoadingEventos ? (
            <Flex
              align="center"
              justify="center"
              minH="120px"
              direction="column"
              gap={2}
            >
              <Spinner size="lg" color="red.500" thickness="4px" speed="0.7s" />
              <Text color="gray.500" fontWeight="medium">
                Carregando histórico...
              </Text>
            </Flex>
          ) : logsAlteracoes.length === 0 ? (
            <Flex
              align="center"
              justify="center"
              minH="80px"
              color="gray.400"
              fontWeight="medium"
              direction="column"
              gap={2}
            >
              <MdHistory size={32} color="#CBD5E0" />
              <Text>Nenhuma alteração registrada para este dia.</Text>
            </Flex>
          ) : (
            <Box overflowX="auto">
              <Table
                variant="striped"
                colorScheme="gray"
                borderRadius="lg"
                boxShadow="md"
                minW="700px"
              >
                <Thead bg="#E31E2C">
                  <Tr>
                    <Th color="white">Data</Th>
                    <Th color="white">Hora</Th>
                    <Th color="white">Evento</Th>
                    <Th color="white">Tipo</Th>
                    <Th color="white">Campo</Th>
                    <Th color="white">Valor Original</Th>
                    <Th color="white">Novo Valor</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {logsAlteracoes.map((log, index) => {
                    const campo = log.campo_alterado?.toLowerCase();
                    const tipo =
                      campo === "inserido"
                        ? "Inserido"
                        : campo === "excluido"
                          ? "Excluído"
                          : "Alterado";
                    const badgeColor =
                      tipo === "Inserido"
                        ? "green"
                        : tipo === "Excluído"
                          ? "red"
                          : "yellow";
                    return (
                      <Tr
                        key={index}
                        bg={index % 2 === 0 ? "gray.50" : "white"}
                        _hover={{ bg: "gray.100" }}
                        transition="background 0.2s"
                      >
                        <Td>{formatDate(log.data_alteracao)}</Td>
                        <Td>{log.hora_alteracao}</Td>
                        <Td display="flex" alignItems="center" gap={2}>
                          {getEventoIcon(log.descricao_evento)}
                          <span>{log.descricao_evento}</span>
                        </Td>
                        <Td>
                          <Badge colorScheme={badgeColor}>{tipo}</Badge>
                        </Td>
                        <Td>
                          <Tooltip
                            label={log.campo_alterado}
                            isDisabled={
                              !log.campo_alterado ||
                              log.campo_alterado.length < 10
                            }
                            fontSize="sm"
                          >
                            <span>{log.campo_alterado}</span>
                          </Tooltip>
                        </Td>
                        <Td fontWeight="400" color="red.600">
                          <Tooltip
                            label={log.valor_original}
                            isDisabled={
                              !log.valor_original ||
                              log.valor_original.length < 8
                            }
                            fontSize="sm"
                          >
                            <span>{log.valor_original}</span>
                          </Tooltip>
                        </Td>
                        <Td fontWeight="600" color="green.700">
                          <Tooltip
                            label={log.novo_valor}
                            isDisabled={
                              !log.novo_valor || log.novo_valor.length < 8
                            }
                            fontSize="sm"
                          >
                            <span>{log.novo_valor}</span>
                          </Tooltip>
                        </Td>
                      </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            </Box>
          )}
        </Box>

        {/* Logs de alteração já enviados para o dia */}
        <Box
          borderWidth="2px"
          borderRadius="2xl"
          p={6}
          boxShadow="2xl"
          bgGradient="linear(to-br, white, gray.50)"
          w="100%"
          borderColor="#E31E2C"
          mt={6}
          mb={4}
        >
          <HStack mb={2} gap={2} align="center">
            <Box
              bg="#E31E2C"
              borderRadius="full"
              p={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <MdHistory color="white" size={28} />
            </Box>
            <Heading as="h3" size="md" color="#E31E2C" fontWeight="bold">
              Log(s) Corrigidos -{" "}
              {formatDate(dataAtual) || "Data não disponível"}
            </Heading>
          </HStack>
          <Divider mb={4} />
          {logsDoDia.length === 0 ? (
            <Flex
              align="center"
              justify="center"
              minH="80px"
              color="gray.400"
              fontWeight="medium"
              direction="column"
              gap={2}
            >
              <MdHistory size={32} color="#CBD5E0" />
              <Text>Nenhuma alteração registrada para este dia.</Text>
            </Flex>
          ) : (
            <Box overflowX="auto">
              <Table
                size="sm"
                variant="striped"
                colorScheme="gray"
                borderRadius="lg"
                boxShadow="md"
                minW="600px"
              >
                <Thead bg="#E31E2C">
                  <Tr>
                    {/* <Th color="white">Data</Th> */}
                    <Th color="white">Evento</Th>
                    <Th color="white">Tipo</Th>
                    <Th color="white">Valor Original</Th>
                    <Th color="white">Novo Valor</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {logsDoDia.map((log, idx) => {
                    const campo = log.campo_alteracao?.toLowerCase();

                    // Nova lógica para determinar o tipo (mesma da tabela principal)
                    let tipo = "Alterado";
                    if (
                      campo === "inserido_inicial" ||
                      campo === "inserido_final" ||
                      campo === "inserido"
                    ) {
                      tipo = "Inserido";
                    } else if (campo === "excluido") {
                      tipo = "Excluído";
                    }

                    const badgeColor =
                      tipo === "Inserido"
                        ? "green"
                        : tipo === "Excluído"
                          ? "red"
                          : "yellow";
                    return (
                      <Tr
                        key={idx}
                        bg={idx % 2 === 0 ? "gray.50" : "white"}
                        _hover={{ bg: "gray.100" }}
                      >
                        {/* <Td>{log.data_original}</Td> */}
                        <Td display="flex" alignItems="center" gap={2}>
                          <MdHistory color="#E31E2C" />
                          <span>{log.nome_evento}</span>
                        </Td>
                        <Td>
                          <Badge colorScheme={badgeColor}>{tipo}</Badge>
                        </Td>
                        <Td fontWeight="400" color="red.600">
                          {log.hora_original}
                        </Td>
                        <Td fontWeight="600" color="green.700">
                          {log.hora_novo}
                        </Td>
                      </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            </Box>
          )}
        </Box>
      </Flex>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay bg="blackAlpha.600" backdropFilter="blur(4px)">
          <AlertDialogContent
            borderRadius="xl"
            bg="white"
            boxShadow="2xl"
            mx={4}
            maxW="sm"
            opacity={isDeleting ? 0.7 : 1}
            cursor={isDeleting ? "not-allowed" : "auto"}
            pointerEvents={isDeleting ? "none" : "auto"}
          >
            <AlertDialogHeader
              fontSize="xl"
              fontWeight="bold"
              color="red.600"
              borderBottom="1px solid"
              borderColor="gray.200"
              pb={2}
            >
              <Flex align="center" gap={2}>
                <MdWarning boxSize={6} color="red.500" />
                Confirmar Exclusão
              </Flex>
            </AlertDialogHeader>

            <AlertDialogBody py={6} color="gray.700">
              <Text>
                Tem certeza que deseja excluir este evento?{" "}
                <Box as="span" fontWeight="semibold" color="red.600">
                  Essa ação não pode ser desfeita.
                </Box>
              </Text>
            </AlertDialogBody>

            <AlertDialogFooter
              borderTop="1px solid"
              borderColor="gray.200"
              pt={4}
              gap={3}
            >
              <Button
                ref={cancelRef}
                onClick={onClose}
                variant="outline"
                colorScheme="gray"
                isDisabled={isDeleting}
              >
                Cancelar
              </Button>
              <Button
                colorScheme="red"
                onClick={async () => {
                  setIsDeleting(true);
                  try {
                    await postExcluirEventoMotorista([
                      { id: eventoParaExcluir },
                    ]);

                    // Atualiza eventos com chamada da API
                    await atualizarEventos();

                    toast({
                      title: "Evento excluído",
                      description: "O evento foi removido com sucesso.",
                      status: "success",
                      duration: 3000,
                      isClosable: true,
                    });
                  } catch (error) {
                    toast({
                      title: "Erro ao excluir",
                      description: "Não foi possível excluir o evento.",
                      status: "error",
                      duration: 4000,
                      isClosable: true,
                    });
                  } finally {
                    setIsDeleting(false);
                    onClose();
                    setEventoParaExcluir(null);
                  }
                }}
                isLoading={isDeleting}
                loadingText="Excluindo..."
              >
                Excluir
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* SSL Certificate Helper Modal */}
      <SSLCertificateHelper
        isOpen={sslHelperDisclosure.isOpen}
        onClose={sslHelperDisclosure.onClose}
        error={sslError}
        baseUrl={sslError?.baseUrl}
      />
    </Box>
  );
}

export default EditarApontamento;
